import { createAction, props } from '@ngrx/store';
import { AddSomeoneElseDto } from '../../../common/dtos/add-someone-else.dto';
import { HttpErrorResponse } from '@angular/common/http';
import {
    CreateInvitationsDto,
    CreateInvitationsResponseDto,
} from '../../interfaces/create-invitations.interface';


export const gatherPinAndDto = createAction(
    '[Access Permissions] Grant Permissions Get Unique Pin',
    props<{
        addSomeoneElseDto: AddSomeoneElseDto;
    }>(),
);

export const gatherPinAndDtoSuccess = createAction(
    '[Access Permissions] Grant Permissions Has Successfully Got Unique Pin',
    props<{
        data: string;
    }>(),
);

export const gatherPinAndDtoError = createAction(
    '[Access Permissions] Grant Permissions Can Not Get Unique Pin',
    props<{
        error: HttpErrorResponse;
    }>(),
);

export const gatherPinAndDtoMultiAccount = createAction(
    '[Access Permissions] Multi Account Grant Permissions Get Unique Pin',
    props<{
        createInvitationsDto: CreateInvitationsDto;
    }>(),
);

export const gatherPinAndDtoMultiAccountSuccess = createAction(
    '[Access Permissions] Multi Account Grant Permissions Has Successfully Got Unique Pin',
    props<{
        data: CreateInvitationsResponseDto;
    }>(),
);

export const gatherPinAndDtoMultiAccountError = createAction(
    '[Access Permissions] Multi Account Grant Permissions Can Not Get Unique Pin',
    props<{
        error: HttpErrorResponse;
    }>(),
);
